// Las horas de UN tramo de Odoo (hr.attendance) a partir de las filas que ALM guarda de él.
//
// Un tramo son dos filas nuestras, entrada y salida, y las dos llevan una copia de lo que
// Odoo tiene del tramo. Esas copias pueden no coincidir: si RRHH corrige la salida y solo
// una de las filas se refresca, `max` de las dos devolvía siempre la cifra vieja (la
// corrección a la baja nunca se veía). Por eso se elige UNA fila como fuente y de ella
// salen las horas; la hora de salida que se pinta sale de esa misma fila.
//
// La fuente es la fila de salida si lleva el cierre de Odoo; si no, la de entrada. Solo si
// la fuente no trae horas se mira la otra.
export function filaFuente(entrada, salida) {
  if (salida && salida.odoo_check_out) return salida;
  if (entrada && entrada.odoo_check_out) return entrada;
  return salida || entrada || null;
}

export function horasDeTramo(entrada, salida) {
  const fuente = filaFuente(entrada, salida);
  const otra = fuente === salida ? entrada : salida;
  for (const f of [fuente, otra]) {
    if (f && f.horas !== null && f.horas !== undefined) return Number(f.horas) || 0;
  }
  return null;
}
